import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { recordNavigation } from "../lib/breadcrumbs.js";

/**
 * Registra cada troca de tela na trilha de passos.
 *
 * Um componente e não um efeito dentro do Layout: o Login vive FORA do
 * Layout, e a sequência "tentei entrar → entrei → quebrou" é justamente a
 * que explica os chamados de autenticação. Renderiza nada.
 */
export function RastreadorDeRotas() {
  const { pathname } = useLocation();
  useEffect(() => recordNavigation(pathname), [pathname]);
  return null;
}
